import React from "react";
import { FormWrapperInputComponent } from "../../../../../common/component/Index";
import Input from "../../../../../common/component/Input";
import TextArea from "../../../../../common/component/TextArea";
import { Radio } from "antd";
import "./PartiallyCashBack.less";
import { BACK_TARGET, REFUND_TYPE } from "./constants";
import { formatMoney } from "../../../../../../../helpers/functions";

function PartiallyCashBack(props) {
  const {
    t,
    operaBooking = "",
    note = "",
    partiallyRefundData = {},
    validation = {},
    setPartiallyRefundData = () => {},
    setOperaBooking = () => {},
    setNote = () => {},
    sumRefundCost = 0,
    status = 0,
    email = '',
    isLoginedEmail = false,
  } = props;
  const {
    Name = "",
    RefundType = REFUND_TYPE.CASH_BACK,
    Amount = 0,
    CreditPointRateCode = "",
    backTarget = 1,
    RefundTo = "",
  } = partiallyRefundData;
  const points = sumRefundCost !== 0 && Math.round(Number((Amount) / 1000));
  
  const onChange = (key, value) => {
    let nextValues = { ...partiallyRefundData };
    nextValues[key] = value;
    setPartiallyRefundData(nextValues);
  };

  const radioStyle = {
    display: "block",
    height: "30px",
    lineHeight: "30px",
  };

  const renderBody = () => {
    if (RefundType === REFUND_TYPE.CASH_BACK) {
      return (
        <>
          <FormWrapperInputComponent labelTitle={t(`item.order.operaBooking`)}>
            <Input
              placeholder={t(`item.order.operaBooking`)}
              type={`text`}
              className={`form-control`}
              name={`operaBooking`}
              onChange={(e) => setOperaBooking(e.target.value)}
              value={operaBooking}
            />
          </FormWrapperInputComponent>

          <FormWrapperInputComponent labelTitle={t(`item.order.note`)}>
            <TextArea
              value={note}
              placeholder={t(`item.order.note`)}
              name={`note`}
              onChange={(e) => setNote(e.target.value)}
            />
          </FormWrapperInputComponent>
        </>
      );
    }
    return (
      <>
        <FormWrapperInputComponent
          isValidation={true}
          dataValidation={Name}
          validation={validation.Name}
          labelTitle={t(`item.tour.partialyCashBack.lblTypeName`)}
        >
          <Input
            placeholder={t(`item.tour.partialyCashBack.lblTypeName`)}
            type={`text`}
            className={`form-control`}
            name={`Name`}
            onChange={(e) => onChange("Name", e.target.value)}
            value={Name}
          />
        </FormWrapperInputComponent>
        <fieldset className="partially-cash-back__fieldset">
          <legend className="partially-cash-back__fieldset__legend">
            {t(`item.tour.partialyCashBack.lblConfig`)}
          </legend>
          <FormWrapperInputComponent
            isValidation={true}
            validation={validation.backValue}
            labelTitle={t(`item.tour.partialyCashBack.lblBackValue`)}
          >
            <Input
              placeholder={t(`item.tour.partialyCashBack.lblBackValue`)}
              type={`text`}
              className={`form-control`}
              name={`backValue`}
              onChange={(e) => onChange("Amount", Number(e.target.value))}
              value={Amount}
            />
            {status === 4 && (
              <span style={{ position: "absolute", top: 0, right: 0 }}>{`${t(
                `item.tour.partialyCashBack.lblRemain`
              )} ${
                sumRefundCost !== 0 ? formatMoney(sumRefundCost) : 0
              }`}</span>
            )}
          </FormWrapperInputComponent>
          <FormWrapperInputComponent
            isValidation={true}
            dataValidation={CreditPointRateCode}
            validation={validation.CreditPointRateCode}
            labelTitle={t(`item.tour.partialyCashBack.lblLoyaltyCode`)}
          >
            <Input
              placeholder={t(`item.tour.partialyCashBack.lblLoyaltyCode`)}
              type={`text`}
              className={`form-control`}
              name={`CreditPointRateCode`}
              onChange={(e) => onChange("CreditPointRateCode", e.target.value)}
              value={CreditPointRateCode}
            />
          </FormWrapperInputComponent>
          {status === 4 && (
            <div className="partially-cash-back__points">
              <span>{`${t(
                `item.tour.partialyCashBack.lblPoints`
              )} ${points}`}</span>
            </div>
          )}
        </fieldset>
        <Radio.Group
          onChange={(e) => onChange("backTarget", e.target.value)}
          value={backTarget}
        >
          <Radio style={radioStyle} value={BACK_TARGET.OWNER}>
            {t(`item.tour.partialyCashBack.lblBackToOwner`)} | {" "}
              <span style={isLoginedEmail ? {} : {color: 'red'}}>{email}</span>
          </Radio>
          <Radio style={radioStyle} value={BACK_TARGET.OTHER}>
            {t(`item.tour.partialyCashBack.lblBackToOther`)}
          </Radio>
        </Radio.Group>
        {backTarget === BACK_TARGET.OTHER && (
          <FormWrapperInputComponent
            isValidation={true}
            dataValidation={RefundTo}
            validation={validation.RefundTo}
            labelTitle={t(`item.tour.partialyCashBack.lblSentPointToEmail`)}
          >
            <Input
              placeholder={t(`item.tour.partialyCashBack.lblSentPointToEmail`)}
              type={`text`}
              className={`form-control`}
              name={`RefundTo`}
              onChange={(e) => onChange("RefundTo", e.target.value)}
              value={RefundTo}
            />
          </FormWrapperInputComponent>
        )}
      </>
    );
  };

  return (
    <>
      <Radio.Group
        onChange={(e) => onChange("RefundType", e.target.value)}
        value={RefundType}
      >
        <Radio style={radioStyle} value={REFUND_TYPE.CASH_BACK}>
          {t(`item.tour.partialyCashBack.lblCashBack`)}
        </Radio>
        <Radio style={radioStyle} value={REFUND_TYPE.POINT_BACK}>
          {t(`item.tour.partialyCashBack.lblPointBack`)}
        </Radio>
      </Radio.Group>
      {renderBody()}
    </>
  );
}

export default PartiallyCashBack;
